import { render, staticRenderFns } from "./PayByCash.vue?vue&type=template&id=528ed4bc"
import script from "./PayByCash.vue?vue&type=script&lang=js"
export * from "./PayByCash.vue?vue&type=script&lang=js"
import style0 from "./PayByCash.vue?vue&type=style&index=0&id=528ed4bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports